import React, { memo } from 'react';
import classNames from 'classnames/bind';
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
export var Flag = /*#__PURE__*/memo(function (_ref) {
  var srcIcon = _ref.srcIcon,
    classname = _ref.classname;
  return /*#__PURE__*/React.createElement("img", {
    alt: "",
    className: cn('flag', classname),
    loading: "lazy",
    src: srcIcon
  });
});